import { MemberCardsContext } from '@views/contexts'
import { useContext } from 'react'

export const useMemberCards = () => useContext(MemberCardsContext)
